import ToggleSwitchFilter from '../../../components/filter/ToggleSwitchFilter';
import { withSearch } from '@elastic/react-search-ui';

function ArchiveImageFilter({ setFilter, removeFilter, filters }) {
  return (
    <ToggleSwitchFilter
      fieldId="image"
      filters={filters}
      id="with-images"
      label="Only show records with images"
      removeFilter={removeFilter}
      setFilter={setFilter}
    />
  );
}

export default withSearch(({ setFilter, removeFilter, filters }) => ({
  setFilter,
  removeFilter,
  filters,
}))(ArchiveImageFilter);
